import { INITIAL_INVENTORY_COUNTS_SEARCH_PARAMS } from 'src/views/inventory-count/partials/Constants'
import { SET_INVENTORY_COUNTS_SEARCH_PARAMS } from '../actions/actionType'

const initialState = {
  inventoryCounts: [],
  searchParams: INITIAL_INVENTORY_COUNTS_SEARCH_PARAMS,
}

export default function InventoryCountsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_INVENTORY_COUNTS_SEARCH_PARAMS:
      return { ...state, searchParams: action.payload }
    default:
      return state
  }
}
